namespace TabAurous {

    @Serenity.Decorators.registerEditor()
    export class MFGProcessLookup extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, OMS.DepartmentProcessDetailsRow> {

        public WorkshopId: number;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            return OMS.DepartmentProcessDetailsRow.lookupKey;
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var results = Q.getLookup(OMS.DepartmentProcessDetailsRow.lookupKey);
            
            let items = super.getItems(results);
            if (q.isNumber(this.WorkshopId)) {

                let filters = {
                    DepartmentId: [this.WorkshopId, 0]
                };
                
                items = q.Filter(items, filters)
            }              
            return items;
        }

    }

    
}
